import {ReplaySubject, combineLatest} from 'rxjs';
import {filter} from 'rxjs/operators';
import {uiMsg$} from '@/ui';
import {contracts$, spots$, marginPairs$} from '@/config';
import {contract$} from './contract';
import {spot$} from './spot';
import type {SpotTradeMode, TradePair, TradeType} from '@/types';

export const tradePair$ = new ReplaySubject<TradePair>(1);

export interface FUStateSymbol {
  type: 'state-symbol';
  tradeType: TradeType;
  symbol: string;
  mode: SpotTradeMode;
}
const stateSymbol$ = uiMsg$.pipe(filter((o: FUStateSymbol) => o.type === 'state-symbol'));

combineLatest([stateSymbol$, spots$, marginPairs$, contracts$]).subscribe(
  ([stateSymbol, spots, marginPairs, contracts]) => {
    const {tradeType, symbol, mode} = stateSymbol;
    if (tradeType === 'Spot') {
      const spot = (mode === 'Margin' ? marginPairs : spots).find((spot) => spot.symbol === symbol);
      if (!spot) {
        return;
      }
      spot$.next(spot);
      tradePair$.next(spot);
      return;
    }
    if (['Perpetual', 'PerpetualV2'].indexOf(tradeType) > -1) {
      const contract = contracts.find((contract) => contract.symbol === symbol);
      if (!contract) {
        return;
      }
      contract$.next(contract);
      tradePair$.next(contract);
    }
  }
);
